import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MobileAppWrapper } from "../mobile.app.wrapper.component";
import { JoiAppData } from "globals/store/app.data";
import { MobileManageAppsComponent } from "./mobile-manage-apps-dialog.component";
import { openDialogGetResult } from "../../../helpers/angular-helpers";
import { ActionButtonComponent } from "../../nav-bar/action-button.component";
import { IconComponent } from "../../icon/icon.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'mobile-login-wrapper',
    template: `
<icon class="joi-icon" icon="joi_logo_white"></icon>
<div class="welcome">welcome</div>
<ng-content></ng-content>
<action-button class="main-button" [text]="buttonText" [disabled]="disabled" (click)="disabled ? null : onButtonClick.emit()"></action-button>
<ng-content select=".bottom"></ng-content>
<div style="flex: 1;"></div>
<div class="bottom">
  <span (click)="helpers.openInNewTab('https://www.joi.events/privacy')">Privacy Policy</span>
  <ng-container *ngIf="!!apps?.length"> | <span (click)="manageApps()">Manage Apps</span></ng-container>
</div>
<div class="bottom-space" *ngIf="bottomSpace"></div>
`,
    styleUrls: ['./mobile-login-wrapper.scss', '../../../page.scss'],
    standalone: true,
    imports: [ActionButtonComponent, IconComponent, CommonModule]
})
export class MobileLoginWrapperComponent extends MobileAppWrapper<MobileLoginWrapperComponent> {
  @Input() disabled: boolean = true
  @Input() buttonText = 'Open event app'
  @Input() apps: JoiAppData[]
  @Input() instructions = 'Find your event'
  @Input() bottomSpace

  @Output() onButtonClick: EventEmitter<void> = new EventEmitter()
  @Output() appsUpdated: EventEmitter<JoiAppData[]> = new EventEmitter()
  
  async manageApps() {
    const apps = await openDialogGetResult<JoiAppData[]>(this.dialog, MobileManageAppsComponent, {
      width: '90vw',
      autoFocus: false,
      data: [...this.apps],
      backdropClass: 'clear',
      disableClose: true
    })
    if (apps && apps.length !== this.apps.length) this.appsUpdated.emit(apps)

  }
}
